<template>
  <div class="contain">
    <div class="wrapper" v-if="inputType === 'basic'">
      <mx-address-input
        :secondary-confirmation="true"
        @confirm="inputFinish"
      ></mx-address-input>
    </div>
    <div class="wrapper" v-if="inputType === 'label'">
      <mx-address-input
        :labelWidth="'5em'"
        :labelAlign="'center'"
        :secondary-confirmation="true"
        @confirm="inputFinish"
      ></mx-address-input>
    </div>
    <div class="wrapper" v-if="inputType === 'input'">
      <mx-address-input
        :inputAlign="'center'"
        :secondary-confirmation="true"
        @confirm="inputFinish"
      ></mx-address-input>
    </div>
    <div class="wrapper" v-if="inputType === 'buttonStyle'">
      <mx-address-input
        :submitWidth="'20em'"
        :submitColor="'#00CBB8'"
        :submitText="'确认'"
        :secondary-confirmation="true"
        @confirm="inputFinish"
      ></mx-address-input>
    </div>
    <div
      class="wrapper"
      v-if="
        inputType === 'seconaryConfirmation' ||
        inputType === 'noSeconaryConfirmation'
      "
    >
      <mx-address-input
        :secondary-confirmation="isShow"
        @confirm="inputFinish"
      ></mx-address-input>
    </div>
    <div class="wrapper" v-if="inputType === 'isExtra'">
      <mx-address-input
        :extraneousInformation="extraneousInformation"
        :secondary-confirmation="false"
        @confirm="inputFinish"
      ></mx-address-input>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AddressEditDemo',
  data() {
    return {
      inputType: '',
      isShow: true, // 是否展示二次弹窗
    }
  },
  computed: {
    extraneousInformation() {
      return [
        {
          key: 'postalCode',
          label: '邮政编码',
          maxlength: 6,
          placeholder: '输入邮政编码',
        },
        {
          key: 'prizeName',
          label: '奖品名称',
          maxlength: 15,
          placeholder: '输入奖品名称',
        },
      ]
    },
  },
  methods: {
    inputFinish(data) {
      console.log('data: ', data)
    },
  },
  mounted() {
    this.inputType = this.$route.query.type
    console.log('type: ', this.inputType)
    if (this.inputType === 'seconaryConfirmation') {
      this.isShow = true
    } else if (this.inputType === 'noSeconaryConfirmation') {
      this.isShow = false
    }
  },
}
</script>
<style lang="scss" scoped>
.contain {
  width: 375px;
  background-color: #f7f8fa;
  display: flex;
  justify-content: center;
}
</style>
